import { SelectionField } from './../../selection-field'
import { RadioButtonFieldProps } from './RadioButtonField.types'

export function RadioButtonField({
  label,
  supportingText,
  id,
  disabled,
  className,
  variant = 'transparent',
  ...rest
}: RadioButtonFieldProps) {
  return (
    <SelectionField
      label={label}
      supportingText={supportingText}
      disabled={disabled}
      className={className}
      variant={variant}
      select="radio"
      {...rest}
    />
  )
}
